/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ platform: NonNullable<unknown> }} Gc_Resources_Download_ButtonInputs */

const en_gc_resources_download_button = /** @type {(inputs: Gc_Resources_Download_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Download for ${i?.platform}`)
};

const zh_gc_resources_download_button = /** @type {(inputs: Gc_Resources_Download_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`下载 ${i?.platform} 版`)
};

/**
* | output |
* | --- |
* | "Download for {platform}" |
*
* @param {Gc_Resources_Download_ButtonInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_button = /** @type {((inputs: Gc_Resources_Download_ButtonInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_ButtonInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_button(inputs)
	return zh_gc_resources_download_button(inputs)
});
export { gc_resources_download_button as "gc.resources.download.button" }